import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@saatva-bits/pattern-library.components.modal'
import { shipmentDeliveryInfoConfig } from './copy/shipmentDeliveryInfoConfig'
import DeliveryInfoModalTitle from './partials/DeliveryInfoModalTitle'
import DeliveryInfoModalContent from './partials/DeliveryInfoModalContent'
import DeliveryInfoModalFooter from './partials/DeliveryInfoModalFooter'
import styles from './styles.module.scss'
import { getDeliverySubType } from '@/utils/order'

const ShipmentDeliveryInfoModal = ({ shipment = {}, isModalVisible, handleCloseDeliveryInfoModalOnClick }) => {
    const deliveryContentData = useMemo(() => {
        if (!Object.keys(shipment).length) return {}
        const deliverySubType = getDeliverySubType(shipment)
        return shipmentDeliveryInfoConfig[shipment?.type][deliverySubType]
    }, [shipment])

    if (!shipment || !deliveryContentData) return null
    return (
        <Modal
            type='popup'
            modalTitle={<DeliveryInfoModalTitle deliveryContentData={deliveryContentData} />}
            modalLabel={deliveryContentData['title'] || 'Delivery Info Modal'}
            modalFooter={<DeliveryInfoModalFooter handleCloseDeliveryInfoModalOnClick={handleCloseDeliveryInfoModalOnClick} />}
            className={styles.modal}
            titleClassName={styles.modalTitle}
            contentWrapperClassName={styles.contentWrapper}
            footerClassName={styles.modalFooterContainer}
            isModalVisible={isModalVisible}
            onModalClose={handleCloseDeliveryInfoModalOnClick}
            hasOverlay
        >
            <DeliveryInfoModalContent deliveryContentData={deliveryContentData} />
        </Modal>
    )
}

ShipmentDeliveryInfoModal.propTypes = {
    shipment: PropTypes.object,
    isModalVisible: PropTypes.bool,
    handleCloseDeliveryInfoModalOnClick: PropTypes.func
}

export default ShipmentDeliveryInfoModal
